export const LOCALIZED_INSPIRATION_BLOG_SLUGS = [
  'inspirationen', 'inspirations', 'inspiracje', 'ispirazioni', 'inspiration', 'inspiraciok',
];
